import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Input, Output, signal, Signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { StoreSpecificConfigService } from '@scalefast/config-angular';
import { LoginService } from '@scalefast/ecommerce-core';
import { Observable } from 'rxjs';

import { toSignal } from '@angular/core/rxjs-interop';
import { MenuItem } from 'src/app/core/interfaces';
import { PohService } from 'src/app/shared/services';
import { NavMenuService } from 'src/app/shared/services/nav-menu.service';
import { AppCountrySelectComponent } from '../country-select/country-select.component';
import { AppLoginButtonComponent } from '../login/login-button.component';
import { AppStoreNavItemComponent } from '../store-nav-item/store-nav-item.component';
import { NgClass, NgStyle } from '@angular/common';

@Component({
  selector: 'app-store-nav',
  standalone: true,
  imports: [NgStyle, NgClass, AppStoreNavItemComponent, RouterLink, AppCountrySelectComponent, AppLoginButtonComponent],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          opacity: 0,
        }),
      ),
      transition('open => closed', [animate('2s')]),
      transition('closed => open', [animate('0.1s')]),
    ]),
  ],
  templateUrl: 'store-nav.component.html',
  styleUrls: ['./store-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppStoreNavComponent {
  contactZendesk: string = '';
  isLogged$: Observable<boolean>;
  items: Signal<MenuItem[] | undefined>;
  opened = signal(-1);
  private _isMobileOpen: boolean = false;
  isAPohPage: Signal<boolean | undefined>;
  @Output() backdropClick = new EventEmitter<boolean>();
  @Input() isSticky: boolean = false;
  @Input() headerTop: string | undefined;
  @Input() set isMobileOpen(value: boolean) {
    if (value == this._isMobileOpen) {
      return;
    }
    this._isMobileOpen = value;
    this.toggleMenu(this._isMobileOpen);
  }
  @HostListener('window:resize', [])
  onResize() {
    const menu = document.getElementById('primary_nav');
    const menuButton = document.getElementById('dropdown-menu-mobile');
    const menuBackdrop = document.getElementById('menu-backdrop');
    var docWidth = document.documentElement.offsetWidth;
    if (docWidth >= 992) {
      this._isMobileOpen = false;
      menu?.classList.remove('show');
      menuButton?.classList.remove('open');
      menuBackdrop?.classList.remove('show');
      document.documentElement.classList.remove('mob-menu_open');
    } else {
      const navItems = document.querySelectorAll('.navbar__item');
      const megamenu = document.querySelectorAll('.megamenu');
      navItems.forEach((item) => {
        item.classList.remove('show');
      });
      megamenu.forEach((item) => {
        item.classList.remove('show');
      });
    }
  }

  constructor(
    private loginService: LoginService,
    private storeSpecificConfigService: StoreSpecificConfigService,
    private navMenuService: NavMenuService,
    private pohService: PohService,
  ) {
    this.contactZendesk = this.storeSpecificConfigService.get()?.helpUrl?.contact;
    this.items = toSignal(this.navMenuService.navContent$);
    this.isLogged$ = this.loginService.isLogged();
    this.isAPohPage = toSignal(this.pohService.isAPohPage(true));
  }

  get isMobileOpen(): boolean {
    return this._isMobileOpen;
  }

  emitBackdropClick(value: any): void {
    this.backdropClick.emit(value);
  }

  toggleMenu(value: boolean): void {
    if (value == true) {
      document.documentElement.classList.add('mob-menu_open');
    } else {
      document.documentElement.classList.remove('mob-menu_open');
    }
  }
}
